import axios from 'axios';

// agents list
export async function fetchAgentsListAPI() {
	let agentslist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/agentslist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		agentslist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return agentslist;
};

// customers list
export async function fetchCustomersListAPI() {
	let customerslist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/customerslist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		customerslist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return customerslist;
};

//billing address list
export async function fetchBillAddListAPI(customer_id) {
	let custbilladdlist = null;
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lov/custbilladdlist`,
			data: { customer_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		custbilladdlist = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return custbilladdlist;
};

//delivery address list
export async function fetchDelAddListAPI(customer_id) {
	let custdeladdlist = null;
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lov/custdeladdlist`,
			data: { customer_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		custdeladdlist = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return custdeladdlist;
};

// vat input list
export async function fetchVatListAPI() {
	let vatlist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/vatlist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		vatlist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return vatlist;
};

// terms list
export async function fetchTermsListAPI() {
	let termslist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/termslist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		termslist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return termslist;
};

//status list
export async function fetchStatusListAPI(used_by) {
	let statuslist = null;
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lov/statuslist`,
			data: { used_by },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		statuslist = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return statuslist;
}

// units list
export async function fetchUnitsListAPI() {
	let unitslist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/unitslist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		unitslist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return unitslist;
};


// role list
export async function fetchRoleListAPI() {
	let rolelist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/rolelist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		rolelist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return rolelist;
};

//invoice types list
export async function fetchInvTypesListAPI() {
	let invtypeslist = null;
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/invtypeslist`,
			// data: { Data },
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		invtypeslist = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return invtypeslist;
}

// message list
export async function fetchMessageListAPI() {
	let messagelist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/messagelist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		messagelist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return messagelist;
};

// or no list
export async function fetchOrNoListAPI() {
	let ornolist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/ornolist`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		ornolist = data 
		;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return ornolist;
};